module.exports = __webpack_public_path__ + "img/65767.112a14d5.png";